import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; /** for ngModel & forms **/


/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples
*/
import { NgZorroAntdModule } from 'app/ng-zorro.module';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
import { NzFormItemComponent } from 'ng-zorro-antd/form';
import { NzIconDirective, NzIconModule } from 'ng-zorro-antd/icon';

import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);
/*
Base UI includes { ngx-charts } as the base charting library
- Check Docs: https://swimlane.gitbook.io/ngx-charts/examples/pie-charts/pie-grid-chart
- Check Demo: https://swimlane.github.io/ngx-charts/#/ngx-charts/advanced-pie-chart
*/
import { NgxChartsModule } from '@swimlane/ngx-charts'; /* ngx-charts */
import { OrgChartModule } from 'ng2-org-chart'; /* Org Hierarchy Chart */

/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SharedComponentsModule } from '../../ViewModules/shared-components'
import { SharedServicesModule } from '../../ViewModules/shared-services'

/* CountUp */
import { CountUpModule } from 'countup.js-angular2';

/* App */
import { LoginComponent } from './login/login.component';
import { BaseUIContainerComponent } from './base-ui-container/base-ui-container.component';
import { AppLayoutComponent } from './app-layout/app-layout.component';
// import { ClaimsModule } from '../../ViewModules/Claims'

/* Demos -- Component Demos -- Can be removed */
import { DemoDashComponent } from './demo/demo-dash/demo-dash.component';
import { DemoSandboxComponent } from './demo/demo-sandbox/demo-sandbox.component';
import { CaptureProposalComponent } from './demo/capture-proposal/capture-proposal.component';
import { DemoInboxUwComponent } from './demo/demo-inbox-uw/demo-inbox-uw.component';
import { DemoResponsiveTableComponent } from './demo/demo-responsive-table/demo-responsive-table.component';
// import { UIOcrBaseComponent } from './demo/ocr-base/ocr-base.component';
import { OrgHierarchyComponent } from './demo/org-hierarchy/org-hierarchy.component';
import { OrgAgentsComponent } from './demo/org-agents/org-agents.component';
import { DemoClaimsInboxComponent } from './demo/demo-claims/demo-claims-inbox.component';
import { DemoClaimsDetailsComponent } from './demo/demo-claims/demo-claims-details.component';
import { DemoClaimsIntimationComponent } from './demo/demo-claims/demo-claims-intimation/demo-claims-intimation.component';
import { DemoClaimsRegistrationComponent } from './demo/demo-claims/demo-claims-registration/demo-claims-registration.component';
import { SearchComponent } from './ui-components/ui-search/ui-search.component';
import { ClaimsIntimationBulkUploadComponent } from './demo/demo-claims/claims-intimation-bulk-upload/claims-intimation-bulk-upload.component';
import { UiMultirowBasicComponent } from './ui-components/ui-multirow-basic/ui-multirow-basic.component';
import { UiAddressIndComponent } from './ui-components/ui-address-ind/ui-address-ind.component';
// import { AnalyticsTabComponent } from './ui-components/ui-analytics-tab/ui-analytics-tab.component';
import { UiNestedTableComponent } from './ui-components/ui-nested-table/ui-nested-table.component';
import { UiBankAccountDetailsComponent } from './ui-components/ui-bank-account-details/ui-bank-account-details.component';
import { UiInvestigatorTabComponent } from './ui-components/ui-investigator-tab/ui-investigator-tab.component';
import { UiHospitalizationSimpleTabComponent } from './ui-components/ui-hospitalization-simple-tab/ui-hospitalization-simple-tab.component';
import { UiBillDetailsComponent } from './ui-components/ui-bill-details/ui-bill-details.component';
import { UiCannedRepliesComponent } from './ui-components/ui-canned-replies/ui-canned-replies.component';
import { UiQuestionnaireComponent } from './ui-components/ui-questionnaire/ui-questionnaire.component';
import { UiRulesAutoComponent } from './ui-components/ui-rules-auto/ui-rules-auto.component';
import { UiCoveragesHealthComponent } from './ui-coverages-health/ui-coverages-health.component';
// import { OcrBaseComponent } from "@app/BaseFramework/base-ui/ui-components/ocr-base/ocr-base.component";
import { UIOcrBaseComponent } from "./ui-components/ocr-base/ocr-base.component";


// Text diff
import { NgxTextDiffModule } from 'ngx-text-diff';
//Servicing
// import { ServicingInboxComponent } from '@app/BaseFramework/base-ui/servicing-inbox/servicing-inbox.component';
// import { ServicingCardComponent } from '@app/BaseFramework/base-ui/servicing-inbox/servicing-card.component';
// import { ServicingRequestFormComponent } from '@app/BaseFramework/base-ui/servicing-inbox/servicing-request-form.component';
//Customer 360
import { CustomerDashComponent_demo } from './demo/customer/customer-dash.component';
import { CustomerDetailsComponent_demo } from './demo/customer/customer-details/customer-details.component';
import { UiProfileEditComponent } from './ui-components/ui-profile-edit/ui-profile-edit.component';
// Layout: Profile and Notifications
// import { UiPolicySearchAddComponent } from '@app/BaseFramework/base-ui/ui-components/ui-policy-search-add/ui-policy-search-add.component';


import { CustomPipesModule } from '../shared/custom-pipes/custom-pipes.module';
import { ServicingRequestFormComponent_demo } from './servicing-inbox/servicing-request-form.component';
import { ServicingInboxComponent_demo } from './servicing-inbox/servicing-inbox.component';
import { ServicingCardComponent_demo } from './servicing-inbox/servicing-card.component';
import { UiPolicySearchAddComponent_demo } from './ui-components/ui-policy-search-add/ui-policy-search-add.component';

import { SwitchLanguageComponent } from '../core/multi-tenancy/components/switch-language/switch-language.component';

// import { UIOcrVerifierComponent } from './ui-components/ocr-verifier/ocr-verifier.component';
/* END Demos -- Component Demos -- Can be removed */

const ngZorroConfig: NzConfig = {
  message: { nzTop: 24 },
  notification: { nzTop: 240 }
};

@NgModule({
  imports: [
    NgZorroAntdModule,
    TranslateModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    NgxChartsModule,

    //ViewModule
    // ClaimsModule,
    OrgChartModule,
    AngularEditorModule,
    SharedComponentsModule,
    SharedServicesModule,
    CountUpModule,
    NgxTextDiffModule,
    CustomPipesModule,

  ],
  exports: [
    LoginComponent,
    BaseUIContainerComponent,
    AppLayoutComponent,
    NzIconModule,
    NgxChartsModule,
    RouterModule,
    TranslateModule,
    SwitchLanguageComponent
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    NzFormItemComponent,
    NzIconDirective,
    AngularEditorModule,
    CountUpModule,
  ],
  declarations: [
    LoginComponent,
    BaseUIContainerComponent,
    AppLayoutComponent,
    DemoDashComponent,
    DemoSandboxComponent,
    DemoInboxUwComponent,
    DemoResponsiveTableComponent,
    OrgHierarchyComponent,
    OrgAgentsComponent,
    DemoClaimsInboxComponent,
    DemoClaimsDetailsComponent,
    DemoClaimsIntimationComponent,
    DemoClaimsRegistrationComponent,
    ClaimsIntimationBulkUploadComponent,
    UiMultirowBasicComponent,
    UiAddressIndComponent,
    // AnalyticsTabComponent,
    UiNestedTableComponent,
    UiBankAccountDetailsComponent,
    UiInvestigatorTabComponent,
    UiHospitalizationSimpleTabComponent,
    UiBillDetailsComponent,
    UiCannedRepliesComponent,
    UiQuestionnaireComponent,
    UiRulesAutoComponent,
    UiCoveragesHealthComponent,
    // OcrBaseComponent,
    // OcrVerifierComponent,
    CaptureProposalComponent,

    //Customer 360 & Servicing
    CustomerDashComponent_demo,
    CustomerDetailsComponent_demo,
    ServicingRequestFormComponent_demo,
    ServicingInboxComponent_demo,
    ServicingCardComponent_demo,
    UiPolicySearchAddComponent_demo,
    // Profile
    UiProfileEditComponent,
    UIOcrBaseComponent,
    // UIOcrVerifierComponent,
    CaptureProposalComponent,
    SearchComponent,
    SwitchLanguageComponent
  ]
})
export class BaseUIModule { }
